import React from 'react';

const InviteFriends = () => {
  return <h2>Invite Friends</h2>;
};

export default InviteFriends;
